export default "__VITE_ASSET__D32kDMJF__"